
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-076deac4&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./questionType.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./questionType.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-076deac4!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./questionType.vue"),
  /* scopeId */
  "data-v-076deac4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductDocument/components/questionType.vue
// module id = 391
// module chunks = 0